/* eslint-disable react-hooks/rules-of-hooks */
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useExtremeUpgradeRefresh } from 'src/hooks/useExtremeUpgradeRefresh'


import { useTranslation } from 'src/utils/i18n'
import Card from '@mui/material/Card'
import Grid from '@mui/material/Grid'

//@mui/material
import TextField from '@mui/material/TextField'
import InputAdornment from '@mui/material/InputAdornment'

import Image from 'next/image'
import { getInstalledApp } from 'src/@api/dashboard'

import { useDispatch, useSelector } from 'react-redux'
import { setCurrentTab, changeExtremeService } from 'src/store/apps/Common'
import { generateMockData } from 'src/utils'
import ExtremeUpgradeModal from 'src/@core/components/modal/extreme-upgrade'
import { useExtremeFeatureAccessGate } from 'src/hooks/useExtremeFeatureAccessGate'
import { getUserAccountOrder } from 'src/@api/login'
import dayjs from 'dayjs'

const Apps = () => {
  const { t, locale } = useTranslation('common')
  const store = useSelector(state => state.Common)
  const dispatch = useDispatch()
  let Advanced = window.localStorage.getItem('Advanced')
  Advanced = Advanced == null || Advanced == 0 ? true : false

  const [allApp, setAllApp] = useState([])
  const [useApp, setApp] = useState([])
  const [isLoading, setIsLoading] = useState(true) //正在加载获取数据

  // 分页参数
  const [pagination, setPagination] = useState({
    reqNum: 50, // 单次查询数量
    nowOffset: 0, // 偏移量
    maxNum: false // 全部数据查询完毕
  })

  const [advanced, setAdvanced] = useState(true) // 是否购买高级服务
  const [fetchLoading, setFetchLoading] = useState(true) // 数据获取中
  const basicNotOver = [null, ''].includes(store.resetTime.basicUpdateDownloadTime) // 是否未完成一步验证
  const advancedNotOver = [null, ''].includes(store.resetTime.advancedUpdateDownloadTime) // 高级数据未下载完成（空 = 未完成）
  // 高级功能门控（对齐 SpyX）：未绑高级 → 跳 /ios/extreme-verification；数据未就绪 → 暂停渲染
  const { gatePending, showUpgradeModal } = useExtremeFeatureAccessGate(advanced)
  const [justVerified, setJustVerified] = useState(false) // 是否为刚完成验证

  const setAppData = async nowOffset => {
    const username = JSON.parse(localStorage.getItem('DeviceUser')) != null
      ? JSON.parse(localStorage.getItem('DeviceUser')).username
      : ''

    // 获取最近的10笔订单
    let res = await getUserAccountOrder({ page: 1, pageSize: 10 })

    // 查找有限期最长的订单
    const lastOrder = res.data.sort((a, b) => dayjs(b.expire_time).valueOf() - dayjs(a.expire_time).valueOf())[0]

    // 计算是否为增值服务上线前付费用户

    // 增值服务上线前付费用户状态更新

    let response = await getInstalledApp({
      username,
      params: {
        category: 'INSTALLED_APP',
        offset: nowOffset,
        limit: pagination.reqNum,
        deviceUdid:
          JSON.parse(localStorage.getItem('currentDevice')) != null
            ? JSON.parse(localStorage.getItem('currentDevice'))['Unique Identifier']
            : ''
      }
    })
    setIsLoading(false)
    const advanced = username == null || !('advanced' in response) || ['true', true].includes(response?.advanced) // 高级服务开通状态
    setAdvanced(advanced)
    dispatch(changeExtremeService(advanced)) // 更新高级服务状态

    if (response.data.contents == null) {
      setPagination(page => ({ ...page, maxNum: true }))
      setFetchLoading(false)

      return
    }

    if (advanced) { // 开通高级服务
      if (allApp.length > 0) {
        setAllApp(old => ([...old, ...response.data.contents]))
        setApp(old => ([...old, ...response.data.contents]))
      } else {
        setAllApp([...response.data.contents])
        setApp([...response.data.contents])
      }
    } else { // 未开通高级服务生成虚拟数据
      const mockData = generateMockData(response.data.contents)
      setAllApp([...mockData])
      setApp([...mockData])
    }
    setFetchLoading(false)
  }

  useState(() => {
    const nowOffset = 0
    setAppData(nowOffset)
  }, [])

  const dom = useRef(null)

  // 滚动百分比
  const [scroll, setScroll] = useState(0)

  // 升级成功后：预缓冲已在 notify 完成，这里重拉详情读 advanced
  useExtremeUpgradeRefresh(
    useCallback(() => {
      setAdvanced(true)
      setAllApp([])
      setApp([])
      setPagination({ reqNum: 50, nowOffset: 0, maxNum: false })
      setScroll(0)
      setFetchLoading(true)
      setAppData(0)
    }, [])
  )

  // 获取滚动百分比
  useEffect(() => {
    const handScroll = () => {
      if (dom.current) {
        const { scrollTop, scrollHeight, clientHeight } = dom.current
        const progress = (scrollTop / (scrollHeight - clientHeight)) * 100

        setScroll(progress.toFixed(0))
      }
    }

    const currentRef = dom.current
    if (currentRef) {
      currentRef.addEventListener('scroll', handScroll)
    }

    return () => {
      if (currentRef) {
        currentRef.removeEventListener('scroll', handScroll)
      }
    }
  }, [])

  // 监听滚动百分比
  useEffect(() => {
    if (scroll >= 100 && advanced) {
      const nowOffset = pagination.nowOffset + pagination.reqNum
      setPagination(page => ({ ...page, nowOffset }))

      // if (!pagination.maxNum) setAppData(nowOffset)
    }
  }, [scroll])

  // 处理搜索app
  const handleFilter = async e => {
    const query = e?.target?.value?.toLowerCase() || '' // 转换为小写以确保不区分大小写

    if (query === '') {
      setApp(allApp) // 如果输入为空，显示所有应用程序
    } else {
      const filteredApps = allApp.filter(
        app => app.trackName.toLowerCase().includes(query) // 假设每个应用都有一个 'name' 属性
      )
      setApp(filteredApps) // 将过滤后的结果设置到 useApp 中
    }
  }

  useEffect(() => {
    const title = t('Installed app')
    dispatch(setCurrentTab(title))

    return () => dispatch(setCurrentTab(''))
  }, [dispatch, locale])

  return (
    <>
      <div className='bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] Bxl:h-[calc(var(--vh2)*100-94px)] Bxls:Headers5:h-[calc(var(--vh2)*100-149px)] Header5:big:h-[calc(var(--vh2)*100-214px)] bigs:h-[calc(var(--vh2)*100-274px)] flex flex-col relative'>
        {
          !fetchLoading && !gatePending &&
          <>
            {
              (!basicNotOver && !advancedNotOver && !justVerified) ?
                <>
                  {/* 高级服务开通提示 */}
                  {showUpgradeModal && <ExtremeUpgradeModal open />}
                </>
                :
                <>
                  {/* 增值服务 iCloud验证流程 */}
                </>
            }

          </>
        }

        {/* 搜索框 */}
        <div className={`w-full mb-[18px] flex flex-col pt-[15px] px-[15px] ${!advanced ? 'blur-[16px] select-none' : ''}`}>
          <TextField
            fullWidth
            className='h-[40px] bg-[rgba(235,235,239,0.92)] rounded-lg !border-0 text-[16px]'
            size='small'
            onInput={e => {
              advanced && handleFilter(e)
            }}
            placeholder={t('Search app')}
            sx={{
              '& .MuiInputBase-root .MuiOutlinedInput-notchedOutline': { border: 0 },
              '& input::placeholder': { fontSize: '16px', color: '#818187', opacity: 100 }
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>
                  {/* <Icon icon='mdi:magnify' fontSize='1.25rem' /> */}
                  <Image src='/images/contacts/search.svg' width={18} height={18} alt='search'></Image>
                </InputAdornment>
              )
            }}
          />
        </div>
        <div ref={dom} className={`flex-1 px-[24px] pb-[22px] ${advanced ? 'overflow-auto' : 'overflow-hidden blur-[16px] select-none'}`}>
          <Grid container columnSpacing={8.75} rowSpacing={5.25}>
            {useApp.map((row, index) => (
              <Grid
                item
                key={index}
                xs={3}
                md={2}
                lg={2}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%'
                }}
              >
                <Image
                  src={row.artworkUrl60 == '' ? '/images/files/empty1.png' : row.artworkUrl60}
                  width={50}
                  height={50}
                  alt='app'
                  className='flex-shrink-0 rounded-[11px]'
                />
                {/* 应用名固定 12px：sm: 前缀在手机端不生效会退回默认字号导致名称被裁；break-all 让 bundleId 等长词可换行显示完整 */}
                <p
                  className='text-[12px] break-all mt-[4px] overflow-hidden w-full items-end text-center text-[#2E2E2E] font-medium'
                  style={{
                    display: '-webkit-box',
                    WebkitLineClamp: '2',
                    WebkitBoxOrient: 'vertical'
                  }}
                >
                  {row.trackName == '' ? row.bundleId : row.trackName}
                </p>
              </Grid>
            ))}
          </Grid>
        </div>
        {advanced && allApp.length == 0 && !isLoading &&
          <div className='text-center px-2 absolute inset-0 flex justify-center items-center pointer-events-none'>
            {t('It appears theres no data to show here yet')}<br />
            {t('If data exists it may take up to 1 hour to download and appear')}<br />
            {t('We suggest checking back in a little while')}
          </div>}
      </div>
    </>
  )
}

export default Apps


